// import { useParams, useNavigate,Link } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import ContactDetails from '../contact/ContactDetails';
// import ProductView from './ProductView';
// import DocumentDetails from '../DocumentDetails';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// const ProductDetail = () => {
//     const { id } = useParams(); // Get product ID from the URL
//     const navigate = useNavigate();
//     const [productDetails, setProductDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('productInfo');
//     const [showModal, setShowModal] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const didFetchRef = useRef(false); // Use ref to track whether the API has been called

//     // Function to fetch product details
//     const fetchProductDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/products/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             setProductDetails(response.data.Data); // Set the fetched data to state
//         } catch (error) {
//             console.error('Error fetching product details:', error);
//         }
//     };

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchProductDetails(); // Only fetch data if it hasn't been done before
//             didFetchRef.current = true; // Mark that data has been fetched
//         }
//     }, [id]); // This will run only when `id` changes

//     // Handle back button click
//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     // Handle tab click to change active tab
//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                             <h4 className="mb-sm-0 font-size-18 d-flex align-items-center">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Product Details</span>
//                                 </h4>                                  
//                                     <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/product/details/${id}`}>
//                                             {productDetails?.product_name || " Product Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active">Details</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                     <>
//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0 card-bg">
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold font-size-14 text-primary">{productDetails?.product_name}</Card.Title>
//                                     {/* <BiPencil
//                                         className="text-primary hover-effect2"
//                                         style={{ cursor: 'pointer', fontSize: '1.5rem' }}
//                                         onClick={() => {
//                                             setSelectedProduct(productDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} /> */}
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Type:</strong></span>
//                                                 <span className=" text-muted card-value">{productDetails?.product_type || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Price:</strong></span>
//                                                 <span className=" text-muted card-value">{productDetails?.selling_price || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Description:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{productDetails?.description || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>


//                         </>

//                         <div className="row">
//                     <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">

//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'productInfo' ? 'active' : ''}`}
//                                                 onClick={() => handleTabClick('productInfo')}
//                                                 role="tab"
//                                             >
//                                                 Product Details
//                                             </a>
//                                         </li>

//                                     </ul>
//                                     <div className="tab-content p-4">

//                                         {activeTab === "productInfo" && productDetails && (
//                                             <div className="tab-pane active" id="instacne-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <ProductView productData={productDetails} setProductDetails={setProductDetails} />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         </div>
//                                     </div>
//                                     </div>

//                     </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProductDetail;

import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Offcanvas, Button } from 'react-bootstrap';
import {
    FaBox,
    FaTag,
    FaDollarSign,
    FaStickyNote,
    FaInfoCircle
} from "react-icons/fa";
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import ProductView from './ProductView';
import ProductForm from './ProductForm';
import PartnerPricing from '../sales/partner/PartnerPricing';

const ProductDetail = ({ show, onHide, productId }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [productDetails, setProductDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('productInfo');
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [closeOffcanvas, setCloseOffcanvas] = useState(false);
    const [showModalAfterClose, setShowModalAfterClose] = useState(false);
    const [modalProductData, setModalProductData] = useState(null);

    const didFetchRef = useRef(false);
    const [localShow, setLocalShow] = useState(show);

    // Sync with parent show prop
    useEffect(() => {
        setLocalShow(show);
    }, [show]);

    console.log('prid', productId);
    // Function to fetch product details
    const fetchProductDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = productId || id;
            const response = await axios.get(`${backendUrl}/api/products/${currentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setProductDetails(response.data.Data);
        } catch (error) {
            console.error('Error fetching product details:', error);
        }
    };

    // useEffect(() => {
    //     if (show) {
    //         fetchProductDetails();
    //     }
    // }, [show, productId]);
    useEffect(() => {
        if (localShow && productId) {
            setProductDetails(null); // Clear previous data
            fetchProductDetails();
        }
    }, [localShow, productId]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleOffcanvasClose = () => {
        setProductDetails(null);
        setActiveTab('productInfo');
        didFetchRef.current = false;
        onHide();
    };

    // Format currency display
    const formatCurrency = (amount) => {
        if (!amount) return '--';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    };

    // Format product type display
    const formatProductType = (type) => {
        if (!type) return '--';
        return type.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    };
    const editProduct = async (productId, updatedData) => {
        try {
            const formData = new FormData();

            Object.entries(updatedData).forEach(([key, value]) => {
                if (key === "category_id" && Array.isArray(value)) {
                    value.forEach((id, i) => {
                        formData.append(`category_id[${i}]`, id);
                    });
                }
                else if (key === "pricings" && Array.isArray(value)) {
                    value.forEach((p, i) => {
                        formData.append(`pricings[${i}][license_model]`, p.license_model);
                        formData.append(`pricings[${i}][price]`, p.price ?? "");
                        formData.append(`pricings[${i}][deployment_cost]`, p.deployment_cost ?? "");
                        formData.append(`pricings[${i}][min_price]`, p.min_price ?? "");
                        formData.append(`pricings[${i}][deployment_description]`, p.deployment_description ?? "");
                        formData.append(`pricings[${i}][is_default_channel]`, p.is_default_channel ? "1" : "0");
                    });
                }
                else if (key === "product_image" && value) {
                    formData.append("product_image", value);
                }
                else {
                    formData.append(key, value);
                }
            });

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/products/${productId}?_method=PUT`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const updatedProduct = response.data.Data;

            if (updatedProduct) {
                setProductDetails(updatedProduct);

            } else {
                console.error('Update failed, no data returned.');
            }

            setShowModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating product:', error);
            }
        }
    };
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    const [brands, setBrands] = useState({ allBrands: [] });
    const [vendors, setVendors] = useState({ allVendors: [] });
    const fetchCategories = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allCategories = [];

            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allCategories = [...allCategories, ...response.data.category];

            const allCategoriesList = allCategories.filter(cat => !cat.parent_id);

            // All subcategories (categories with parent_id)
            const allSubcategories = allCategories.filter(cat => cat.parent_id);

            setCategories({ allCategoriesList, allSubcategories });
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchBrands = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allBrands = [];



            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allBrands = [...allBrands, ...response.data.brand];


            setBrands({ allBrands });
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };
    const fetchVendors = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            let allVendors = [];

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });

            // const { data, current_page, last_page } = response.data.Data;
            allVendors = [...allVendors, ...response.data.Data];

            setVendors({ allVendors });

        } catch (error) {
            console.error(`Error fetching vendors:`, error);
        }
    };
    return (
        <Offcanvas
            show={localShow}
            onHide={handleOffcanvasClose}
            placement="end"
            style={{ width: '850px', zIndex: 1045 }}
            className="Product-offcanvas"
        >
            {/* Offcanvas Header */}
            <Offcanvas.Header className="border-bottom bg-white py-3">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center">
                        <div className="bg-primary rounded-circle p-2 me-3">
                            <FaBox className="text-white" size={18} />
                        </div>
                        <div>
                            <h5 className="mb-0 fw-bold text-dark">{productDetails?.product_name}</h5>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => {
                                setSelectedProduct(productDetails);
                                setShowModal(true);
                            }}
                        >
                            <BiPencil className="me-1" />
                            Edit Product
                        </Button>

                        <Button
                            variant="light"
                            size="sm"
                            onClick={handleOffcanvasClose}
                            className="border-0"
                        >
                            <BsX size={20} />
                        </Button>
                    </div>
                </div>
            </Offcanvas.Header>

            {/* Offcanvas Body */}
            <Offcanvas.Body className="p-0">
                {/* Product Summary Card */}
                <div>
                    {/* <div className="row g-4">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaTag className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Product Type</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {formatProductType(productDetails?.license_type) || ''}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaDollarSign className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Brand</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {productDetails?.brand?.name|| ''}
                                    </h6>
                                </div>
                            </div>
                        </div>
                       
                    </div> */}
                </div>

                {/* Additional Product Information */}
                {/* {productDetails && (
                    <div className="p-4 border-bottom bg-white">
                        <div className="row g-4">
                            {productDetails?.cost_price && (
                                <div className="col-md-4">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                            <FaDollarSign className="text-success" size={14} />
                                        </div>
                                        <div>
                                            <label className="text-muted small mb-1 d-block">Cost Price</label>
                                            <h6 className="mb-0 fw-semibold text-dark">
                                                {formatCurrency(productDetails.cost_price)}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {productDetails?.sku && (
                                <div className="col-md-4">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                            <FaTag className="text-info" size={14} />
                                        </div>
                                        <div>
                                            <label className="text-muted small mb-1 d-block">SKU</label>
                                            <h6 className="mb-0 fw-semibold text-dark">
                                                {productDetails.sku}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {productDetails?.quantity && (
                                <div className="col-md-4">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                            <FaBox className="text-warning" size={14} />
                                        </div>
                                        <div>
                                            <label className="text-muted small mb-1 d-block">Quantity</label>
                                            <h6 className="mb-0 fw-semibold text-dark">
                                                {productDetails.quantity}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )} */}

                {/* Navigation Tabs */}
                <div className="border-bottom bg-white">
                    <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'productInfo' ? 'active' : ''}`}
                                onClick={() => handleTabClick('productInfo')}
                                role="tab"
                            >
                                <FaInfoCircle className="me-2" size={14} />
                                Product Details
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'partnerPricing' ? 'active' : ''}`}
                                onClick={() => handleTabClick('partnerPricing')}
                                role="tab"
                            >
                                <FaTag className="me-2" size={14} />
                                Partner Pricing
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Tab Content */}
                <div className="tab-content p-4 bg-white" style={{ minHeight: '400px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                    {/* Product Details Tab */}
                    {activeTab === "productInfo" && (
                        <div className="tab-pane active">
                            {productDetails ? (
                                <ProductView
                                    productData={productDetails}
                                    setProductDetails={setProductDetails}
                                />
                            ) : (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading product details...</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Partner Pricing Tab */}
                    {activeTab === "partnerPricing" && (
                        <div className="tab-pane active">
                            <PartnerPricing
                                productId={productId || id}
                                mode="product"
                            />
                        </div>
                    )}
                </div>
            </Offcanvas.Body>

            {/* Product Modal (if you have one) */}
            {showModal && (
                <ProductForm
                    showModal={showModal}
                    handleClose={() => setShowModal(false)}
                    productData={selectedProduct}
                    editProduct={editProduct}
                    productId={productId || id}
                    categories={categories}
                    fetchCategories={fetchCategories}

                    fetchBrands={fetchBrands}
                    brands={brands}
                    vendors={vendors}
                    fetchVendors={fetchVendors}
                />
            )}
        </Offcanvas>
    );
};

export default ProductDetail;